import classNames from 'classnames';
import * as React from 'react';
import { IntlShape, useIntl } from 'react-intl';

import {
  BookingFailedReason,
  InvalidReservationErrors,
  isInvalidReservationError,
} from '../../../../../../../interfaces/reservations';
import css from './BooksErrorMessage.module.scss';

interface Props {
  className?: string;
  errorType: InvalidReservationErrors | BookingFailedReason;
}

const generateRecordInvalidErrorMessages = (
  error: InvalidReservationErrors,
  intl: IntlShape,
): string[] => {
  const arr: string[] = [];
  for (const key of Object.keys(error.details)) {
    if (key === 'base') {
      // keyがbaseであるエラーはそのまま表示するようにする
      const detail = error.details[key];
      arr.push(detail);
    } else {
      const id = `books.errors.${key}`;
      const localized = intl.formatMessage({ id });
      arr.push(localized);
    }
  }

  return arr;
};

const BooksErrorMessage = ({ className, errorType }: Props) => {
  const classes = classNames(css.BooksErrorMessage, className);
  const intl = useIntl();

  let title: string;
  let descriptions: string[];

  if (isInvalidReservationError(errorType)) {
    title = intl.formatMessage({ id: 'books.forms.errorMessageTitle' });
    descriptions = generateRecordInvalidErrorMessages(errorType, intl);
  } else if (
    errorType === BookingFailedReason.Occupied ||
    errorType === BookingFailedReason.Unexpected ||
    errorType === BookingFailedReason.StripeErrorOccurred
  ) {
    descriptions = [];
    descriptions.push(
      intl.formatMessage({ id: `books.forms.errorMessageText.${errorType}` }),
    );
    title = intl.formatMessage({ id: 'books.forms.errorMessageTitle' });
  } else if (errorType === BookingFailedReason.CardError) {
    descriptions = [];
    descriptions.push(
      intl.formatMessage({ id: 'books.forms.cardErrorMessageText' }),
    );
    title = intl.formatMessage({ id: 'books.forms.cardErrorMessageTitle' });
  } else {
    const _: never = errorType;
    throw new Error(`${_} should not be reached`);
  }

  return (
    <div className={classes}>
      <p className={css.BooksErrorMessage__Title}>{title}</p>
      {descriptions.map((d, i) => (
        <p className={css.BooksErrorMessage__Paragraph} key={i}>
          {d}
        </p>
      ))}
    </div>
  );
};

export default BooksErrorMessage;
